import { Controller } from 'stimulus'

export default class extends Controller {

  connect () {
    if ((window.webkit && window.webkit.messageHandlers.scanMode) || (window.android && window.android.scanMode)) {
      this.element.removeAttribute('target')
    }
  }
}
